var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RibbonGroupBase } from '../ribbon-interfaces';
/**
 * Links group implementation for Insert tab
 * @private
 */
var LinksGroup = /** @class */ (function (_super) {
    __extends(LinksGroup, _super);
    function LinksGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get the Ribbon items for Links group
     * @returns {RibbonGroupModel} - Links group model
     * @private
     */
    LinksGroup.prototype.getGroupModel = function () {
        return {
            header: this.localObj.getConstant('Links'),
            groupIconCss: 'e-icons e-de-ctnr-link',
            enableGroupOverflow: true,
            overflowHeader: this.localObj.getConstant('Links'),
            collections: [{
                    items: [{
                            type: 'Button',
                            keyTip: 'I',
                            buttonSettings: {
                                content: this.localObj.getConstant('Link'),
                                iconCss: 'e-icons e-de-ctnr-link',
                                isToggle: false,
                                clicked: this.insertLinkHandler.bind(this)
                            },
                            id: this.ribbonId + '_link',
                            ribbonTooltipSettings: {
                                content: this.localObj.getConstant('Create Hyperlink')
                            }
                        }]
                }]
        };
    };
    LinksGroup.prototype.insertLinkHandler = function () {
        this.container.documentEditor.showDialog('Hyperlink');
    };
    return LinksGroup;
}(RibbonGroupBase));
export { LinksGroup };
